import Index from './index.vue'
import List from '@/modules/ReportCard/Grades/components/List.vue'

export default [
  {
    path: 'grades',
    name: 'grades',
    component: Index,
    title: 'grades',
    redirect: { name: 'grade-list' },
    children: [
      {
        path: 'list',
        name: 'grade-list',
        component: List,
      },
      
    ],
  },
]
